var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-main", { staticClass: "container" }, [
        _c(
          "div",
          [
            _c(
              "v-card",
              [
                _c(
                  "v-tabs",
                  { attrs: { "bg-color": "primary" } },
                  [
                    _c(
                      "v-tab",
                      {
                        attrs: { value: "one" },
                        on: {
                          click: function($event) {
                            _vm.tabselected = "one"
                          }
                        }
                      },
                      [_vm._v("Bookings")]
                    ),
                    _c(
                      "v-tab",
                      {
                        attrs: { value: "two" },
                        on: {
                          click: function($event) {
                            _vm.tabselected = "two"
                          }
                        }
                      },
                      [_vm._v("Report")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm.tabselected === "one"
          ? _c(
              "div",
              [
                _c(
                  "v-row",
                  { staticClass: "tw-flex-grow-0 tw-px-4" },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            "prepend-inner-icon": "mdi-magnify",
                            "background-color": "#fff",
                            "background-opacity": 1,
                            outlined: "",
                            dense: "",
                            placeholder: "Search for a player"
                          },
                          model: {
                            value: _vm.bookingFilters.players,
                            callback: function($$v) {
                              _vm.$set(_vm.bookingFilters, "players", $$v)
                            },
                            expression: "bookingFilters.players"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3", "offset-md": "3" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "tw-mr-4 tw-w-full",
                            attrs: { color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.clearFilters()
                              }
                            }
                          },
                          [_vm._v(" Clear Filters ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                !_vm.mobile
                  ? _c(
                      "v-row",
                      { staticClass: "filter-row" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "filter tw-mx-2",
                            attrs: { cols: "12", md: "6", lg: "3" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "tw-text-sm tw-text-footy-red mb-1",
                                attrs: { for: "country-filter" }
                              },
                              [_vm._v("Country")]
                            ),
                            _c("v-select", {
                              attrs: {
                                items: _vm.countryFilterOptions,
                                label: "Country",
                                "item-text": "name",
                                "item-value": "id",
                                solo: "",
                                dense: ""
                              },
                              on: {
                                change: function($event) {
                                  _vm.bookingFilters.cities = []
                                  _vm.reportFilters.venue = []
                                }
                              },
                              model: {
                                value: _vm.bookingFilters.country,
                                callback: function($$v) {
                                  _vm.$set(_vm.bookingFilters, "country", $$v)
                                },
                                expression: "bookingFilters.country"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "filter",
                            attrs: { cols: "12", md: "6", lg: "3" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "tw-text-sm tw-text-footy-red mb-1",
                                attrs: { for: "cities-filter" }
                              },
                              [_vm._v("Cities")]
                            ),
                            _c("v-select", {
                              staticClass: "tw-w-full",
                              attrs: {
                                items: _vm.cityFilterOptions,
                                label: "City",
                                "item-text": "city_name",
                                "item-value": "city_id",
                                solo: "",
                                multiple: "",
                                dense: "",
                                chips: ""
                              },
                              model: {
                                value: _vm.bookingFilters.cities,
                                callback: function($$v) {
                                  _vm.$set(_vm.bookingFilters, "cities", $$v)
                                },
                                expression: "bookingFilters.cities"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "filter",
                            attrs: { cols: "12", md: "6", lg: "3" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "tw-text-sm tw-text-footy-red mb-1",
                                attrs: { for: "cities-filter" }
                              },
                              [_vm._v("Venue")]
                            ),
                            _c("v-select", {
                              staticClass: "tw-w-full",
                              attrs: {
                                items: _vm.venueOptions,
                                label: "Venue",
                                solo: "",
                                multiple: "",
                                dense: "",
                                chips: ""
                              },
                              model: {
                                value: _vm.bookingFilters.venue,
                                callback: function($$v) {
                                  _vm.$set(_vm.bookingFilters, "venue", $$v)
                                },
                                expression: "bookingFilters.venue"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c("v-snackbar", {
                  staticClass: "center-snackbar",
                  attrs: { color: "primary" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function() {
                          return [
                            _vm.selectedItem
                              ? _c("div", { staticClass: "parent" }, [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.bookedOn))
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.editedOn))
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.players))
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.court))
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.venue))
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.time_period))
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.price))
                                  ]),
                                  _c(
                                    "p",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "red" } },
                                        [_vm._v("mdi-cancel")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.booker))
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.selectedItem.payment))
                                  ]),
                                  _c(
                                    "p",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "white" } },
                                        [_vm._v("mdi-close")]
                                      ),
                                      _vm._v("cancelled")
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2101127249
                  ),
                  model: {
                    value: _vm.snackbar,
                    callback: function($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar"
                  }
                }),
                _c(
                  "v-card",
                  [
                    _c("v-data-table", {
                      staticClass: "elevation-0",
                      staticStyle: { "min-width": "120px", cursor: "pointer" },
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.items,
                        "mobile-breakpoint": "800"
                      },
                      on: { "click:row": _vm.onRowClick },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.Actions",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                item.type == "player_booking" ||
                                item.type == "customer_booking"
                                  ? _c(
                                      "div",
                                      { staticClass: "text-truncate" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "tw-mr-4  cancelBooking-button tw-w-full",
                                            attrs: { color: "#bf4974" },
                                            on: {
                                              click: function($event) {
                                                return _vm.showDialog(
                                                  item,
                                                  $event
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Cancel booking ")]
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "text-truncate" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "tw-mr-4  cancelBooking-button tw-w-full",
                                            attrs: { color: "blue" }
                                          },
                                          [_vm._v(" Cancelled ")]
                                        )
                                      ],
                                      1
                                    )
                              ]
                            }
                          },
                          {
                            key: "item.Booked_on",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(
                                    _vm._s(item.bookedOn + " ") + " O'Clock"
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.edited_on",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                item.editedOn
                                  ? _c(
                                      "div",
                                      { staticClass: "text-truncate" },
                                      [
                                        _vm._v(
                                          _vm._s(item.editedOn + " ") +
                                            " O'Clock"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "item.court",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(_vm._s(item.court))
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.Venue",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(" " + _vm._s(item.venue) + " ")
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.Email",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(_vm._s(item.email))
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.Players",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(_vm._s(item.players))
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.Time_Period",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(_vm._s(item.time_period))
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.Price",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(
                                    _vm._s(item.price.toFixed(2)) +
                                      " " +
                                      _vm._s(item.currency)
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.Paid",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: { "offset-y": "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "div",
                                                _vm._g(
                                                  {
                                                    staticClass: "text-truncate"
                                                  },
                                                  on
                                                ),
                                                [
                                                  item.paid
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "green"
                                                          }
                                                        },
                                                        [_vm._v(" mdi-check ")]
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "red"
                                                          }
                                                        },
                                                        [_vm._v("mdi-close")]
                                                      )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    item.type == "player_booking" ||
                                    item.type == "customer_booking"
                                      ? _c(
                                          "v-list",
                                          [
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.markAsPaid(
                                                      item,
                                                      true
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Mark as Paid")
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.markAsPaid(
                                                      item,
                                                      false
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Mark as Unpaid")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "item.Booker",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(_vm._s(item.booker))
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.Payment",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "text-truncate" }, [
                                  _vm._v(" " + _vm._s(item.payment) + " ")
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2541259835
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              [
                _c(
                  "v-row",
                  { staticClass: "tw-flex-grow-0 tw-px-4 align-end" },
                  [
                    _c("v-col", { attrs: { cols: "12", md: "9" } }),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "tw-mr-4 tw-w-full button",
                            attrs: { color: "red" },
                            on: {
                              click: function($event) {
                                return _vm.generatePDF()
                              }
                            }
                          },
                          [_vm._v(" Run Report ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticClass: "tw-flex-grow-0 tw-px-4 align-end" },
                  [
                    _c("v-col", { attrs: { cols: "12", md: "9" } }),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "tw-mr-4 tw-w-full",
                            attrs: { color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.clearFiltersReport()
                              }
                            }
                          },
                          [_vm._v(" Clear Filters ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticClass: "filter-row" },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "filter tw-mx-2",
                        attrs: { cols: "12", md: "6", lg: "2" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "tw-text-sm tw-text-footy-red mb-1",
                            attrs: { for: "country-filter" }
                          },
                          [_vm._v("Country")]
                        ),
                        _c("v-select", {
                          attrs: {
                            items: _vm.countryFilterOptions,
                            label: "Country",
                            "item-text": "name",
                            "item-value": "id",
                            solo: "",
                            dense: ""
                          },
                          on: {
                            change: function($event) {
                              _vm.reportFilters.cities = []
                              _vm.reportFilters.venue = []
                            }
                          },
                          model: {
                            value: _vm.reportFilters.country,
                            callback: function($$v) {
                              _vm.$set(_vm.reportFilters, "country", $$v)
                            },
                            expression: "reportFilters.country"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "filter",
                        attrs: { cols: "12", md: "6", lg: "2" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "tw-text-sm tw-text-footy-red mb-1",
                            attrs: { for: "cities-filter" }
                          },
                          [_vm._v("Cities")]
                        ),
                        _c("v-select", {
                          staticClass: "tw-w-full",
                          attrs: {
                            items: _vm.CitiesFilterReport,
                            label: "City",
                            "item-text": "city_name",
                            "item-value": "city_id",
                            solo: "",
                            multiple: "",
                            dense: "",
                            chips: ""
                          },
                          model: {
                            value: _vm.reportFilters.cities,
                            callback: function($$v) {
                              _vm.$set(_vm.reportFilters, "cities", $$v)
                            },
                            expression: "reportFilters.cities"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "filter",
                        attrs: { cols: "12", md: "6", lg: "2" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "tw-text-sm tw-text-footy-red mb-1",
                            attrs: { for: "venue-filter" }
                          },
                          [_vm._v("Venue")]
                        ),
                        _c("v-select", {
                          staticClass: "tw-w-full",
                          attrs: {
                            items: _vm.venuFilterReport,
                            label: "Venue",
                            solo: "",
                            multiple: "",
                            dense: "",
                            chips: ""
                          },
                          model: {
                            value: _vm.reportFilters.venue,
                            callback: function($$v) {
                              _vm.$set(_vm.reportFilters, "venue", $$v)
                            },
                            expression: "reportFilters.venue"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "filter",
                        attrs: { cols: "12", md: "6", lg: "2" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "tw-text-sm tw-text-footy-red mb-1",
                            attrs: { for: "group-filter" }
                          },
                          [_vm._v("Pitch Type")]
                        ),
                        _c("br"),
                        _c("v-select", {
                          staticClass: "tw-w-full",
                          attrs: {
                            items: _vm.pitchOptions,
                            label: "Venue",
                            solo: "",
                            multiple: "",
                            dense: "",
                            chips: ""
                          },
                          model: {
                            value: _vm.reportFilters.pitches,
                            callback: function($$v) {
                              _vm.$set(_vm.reportFilters, "pitches", $$v)
                            },
                            expression: "reportFilters.pitches"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "filter",
                        attrs: { cols: "12", md: "6", lg: "2" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "tw-text-sm tw-text-footy-red mb-1",
                            attrs: { for: "format-filter" }
                          },
                          [_vm._v("Date From")]
                        ),
                        _c("br"),
                        _c(
                          "div",
                          { staticClass: "date-picker" },
                          [
                            _c("flat-pickr", {
                              attrs: {
                                config: _vm.datePickerConfig,
                                placeholder: "Select date",
                                name: "date"
                              },
                              model: {
                                value: _vm.reportFilters.date_from,
                                callback: function($$v) {
                                  _vm.$set(_vm.reportFilters, "date_from", $$v)
                                },
                                expression: "reportFilters.date_from"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "filter",
                        attrs: { cols: "12", md: "6", lg: "" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "tw-text-sm tw-text-footy-red mb-1",
                            attrs: { for: "group-filter" }
                          },
                          [_vm._v("Date To")]
                        ),
                        _c("br"),
                        _c(
                          "div",
                          { staticClass: " date-picker" },
                          [
                            _c("flat-pickr", {
                              attrs: {
                                config: _vm.datePickerConfig,
                                placeholder: "Select date",
                                name: "date"
                              },
                              model: {
                                value: _vm.reportFilters.date_to,
                                callback: function($$v) {
                                  _vm.$set(_vm.reportFilters, "date_to", $$v)
                                },
                                expression: "reportFilters.date_to"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { ref: "pdfContent" },
                  [
                    _c(
                      "v-card",
                      { attrs: { subtitle: "Subtitle", text: "..." } },
                      [
                        _vm.pdf
                          ? _c(
                              "v-row",
                              { staticClass: "tw-flex-grow-0 tw-px-4" },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("strong", [_vm._v("Country")]),
                                    _vm._v(
                                      ": " +
                                        _vm._s(
                                          _vm.reportFilters.country ===
                                            "e2c3e9c6-2477-4f71-a056-d37a9b3f60c9"
                                            ? "Netherland"
                                            : "USA"
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "tw-flex tw-gap-1",
                                    attrs: { cols: "12", md: "4" }
                                  },
                                  [
                                    _c("strong", [_vm._v("Cities")]),
                                    _vm._v(": "),
                                    _c(
                                      "ol",
                                      _vm._l(_vm.reportFilters.cities, function(
                                        item,
                                        i
                                      ) {
                                        return _c("li", { key: i }, [
                                          _vm._v(
                                            _vm._s(
                                              " " +
                                                (i + 1) +
                                                ". " +
                                                _vm.getcityName(item)
                                            )
                                          )
                                        ])
                                      }),
                                      0
                                    )
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "tw-flex tw-gap-2",
                                    attrs: { cols: "12", md: "5" }
                                  },
                                  [
                                    _c("strong", [_vm._v("Venue")]),
                                    _vm._v(": "),
                                    _c(
                                      "ul",
                                      _vm._l(_vm.reportFilters.venue, function(
                                        item,
                                        i
                                      ) {
                                        return _c("li", { key: i }, [
                                          _vm._v(
                                            _vm._s(" " + (i + 1) + ". " + item)
                                          )
                                        ])
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.pdf
                          ? _c(
                              "v-row",
                              { staticClass: "tw-flex-grow-0 tw-px-4" },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("strong", [_vm._v("Date From")]),
                                    _vm._v(
                                      ":" +
                                        _vm._s(_vm.reportFilters.date_from) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("strong", [_vm._v("Date To")]),
                                    _vm._v(
                                      ":" +
                                        _vm._s(_vm.reportFilters.date_to) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("br"),
                        _c("hr"),
                        _c("br"),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _c("strong", [_vm._v("Payment Method")])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [_vm._v("Price")])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [_vm._v("LM")])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [_vm._v("Footy App")])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [_vm._v("Refund")])
                            ])
                          ],
                          1
                        ),
                        _c("hr"),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm._v(" - "),
                              _c("span", { staticClass: "tw-mx-4" }, [
                                _vm._v("Ideal")
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalIdealPrice
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalIdealPrice.toFixed(2)
                                  ) +
                                  " "
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalIdealPriceLM
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalIdealPriceLM.toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalIdealPricePWA
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalIdealPricePWA.toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalIdealPriceRefund
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalIdealPriceRefund.toFixed(2)
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm._v(" - "),
                              _c("span", { staticClass: "tw-mx-4" }, [
                                _vm._v("Credit Card")
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalCreditCardPrice
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalCreditCardPrice.toFixed(2)
                                  ) +
                                  " "
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalCreditCardPriceLM
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalCreditCardPriceLM.toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalCreditCardPricePWA
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalCreditCardPricePWA.toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalCreditCardPriceRefund
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalCreditCardPriceRefund.toFixed(
                                          2
                                        )
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm._v(" - "),
                              _c("span", { staticClass: "tw-mx-4" }, [
                                _vm._v("Other (Paypal, etc)")
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalOtherPaymentPrice
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalOtherPaymentPrice.toFixed(2)
                                  ) +
                                  " "
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalOtherPaymentPrice
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalOtherPaymentPrice.toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€" ? "00,00" : "00.00"
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalOtherPaymentPriceRefund
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalOtherPaymentPriceRefund.toFixed(
                                          2
                                        )
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm._v(" - "),
                              _c("span", { staticClass: "tw-mx-4" }, [
                                _vm._v("On Location")
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalOnLocationPrice
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalOnLocationPrice.toFixed(2)
                                  ) +
                                  " "
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalOnLocationPrice
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalOnLocationPrice.toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€" ? "00,00" : "00.00"
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalOnLocationPriceRefund
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalOnLocationPriceRefund.toFixed(
                                          2
                                        )
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm._v(" - "),
                              _c("span", { staticClass: "tw-mx-4" }, [
                                _vm._v("Invoice")
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalInvoicePrice
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalInvoicePrice.toFixed(2)
                                  ) +
                                  " "
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalInvoicePrice
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalInvoicePrice.toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€" ? "00,00" : "00.00"
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalInvoicePriceRefund
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalInvoicePriceRefund.toFixed(2)
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        ),
                        _c("hr"),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _c("strong", [_vm._v("Gross Sales")])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currency) +
                                    " " +
                                    _vm._s(
                                      _vm.currency == "€"
                                        ? _vm.totalpriceCalculated
                                            .toString()
                                            .replace(".", ",")
                                        : _vm.totalpriceCalculated
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currency) +
                                    " " +
                                    _vm._s(
                                      _vm.currency == "€"
                                        ? _vm.totalpriceCalculatedLM
                                            .toFixed(2)
                                            .toString()
                                            .replace(".", ",")
                                        : _vm.totalpriceCalculatedLM.toFixed(2)
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currency) +
                                    " " +
                                    _vm._s(
                                      _vm.currency == "€"
                                        ? _vm.totalpriceCalculatedPWA
                                            .toFixed(2)
                                            .toString()
                                            .replace(".", ",")
                                        : _vm.totalpriceCalculatedPWA.toFixed(2)
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm._v(" - "),
                              _c("span", { staticClass: "tw-mx-4" }, [
                                _vm._v("Refunds")
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalpriceToRefundLM
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalpriceToRefundLM
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalpriceToRefundPWA
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalpriceToRefundPWA
                                  ) +
                                  " "
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalpriceToRefund
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalpriceToRefund
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        ),
                        _c("hr"),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm.reportFilters.country ===
                              "e2c3e9c6-2477-4f71-a056-d37a9b3f60c9"
                                ? _c("strong", [
                                    _vm._v(" Total incl BTW (9%) ")
                                  ])
                                : _vm.reportFilters.country ===
                                  "cf598eb6-0dd5-4ce7-9e86-ebcb4c9b55a5"
                                ? _c("strong", [_vm._v("Total incl BTW (0%)")])
                                : _c("strong", [_vm._v("Total incl BTW (9%)")])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currency) +
                                    " " +
                                    _vm._s(
                                      _vm.currency == "€"
                                        ? _vm.totalCalculatedAmountAfterRefund
                                            .toString()
                                            .replace(".", ",")
                                        : _vm.totalCalculatedAmountAfterRefund
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currency) +
                                    " " +
                                    _vm._s(
                                      _vm.currency == "€"
                                        ? _vm.totalCalculatedAmountAfterRefundLM
                                            .toString()
                                            .replace(".", ",")
                                        : _vm.totalCalculatedAmountAfterRefundLM
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currency) +
                                    " " +
                                    _vm._s(
                                      _vm.currency == "€"
                                        ? _vm.totalCalculatedAmountAfterRefundPWA
                                            .toString()
                                            .replace(".", ",")
                                        : _vm.totalCalculatedAmountAfterRefundPWA
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm._v(" BTW ")
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalCalculatedAmountBTW
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalCalculatedAmountBTW.toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? Number(_vm.totalCalculatedAmountBTWLM)
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : Number(
                                          _vm.totalCalculatedAmountBTWLM
                                        ).toFixed(2)
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? Number(_vm.totalCalculatedAmountBTWPWA)
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")
                                      : Number(
                                          _vm.totalCalculatedAmountBTWPWA
                                        ).toFixed(2)
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "tw-flex-grow-0 tw-px-4" },
                          [
                            _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                              _vm._v(" Net Sales ")
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalCalculatedNetSale
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalCalculatedNetSale
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalCalculatedNetSaleLM
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalCalculatedNetSaleLM
                                  )
                              )
                            ]),
                            _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                              _vm._v(
                                _vm._s(_vm.currency) +
                                  " " +
                                  _vm._s(
                                    _vm.currency == "€"
                                      ? _vm.totalCalculatedNetSalePWA
                                          .toString()
                                          .replace(".", ",")
                                      : _vm.totalCalculatedNetSalePWA
                                  )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
      ]),
      _c(
        "div",
        { staticClass: "tw-w-full tw-flex tw-justify-start tw-mb-3" },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "1000px" },
              model: {
                value: _vm.cancelDialog,
                callback: function($$v) {
                  _vm.cancelDialog = $$v
                },
                expression: "cancelDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "tw-p-4 tw-pb-8" },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline ml-4" }, [
                      _vm._v("Are you sure you want delete this Booking ?")
                    ])
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "px-8" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "w-32 tw-mr-2",
                          staticStyle: { width: "200px" },
                          attrs: { color: "secondary" },
                          on: {
                            click: function($event) {
                              _vm.cancelDialog = false
                            }
                          }
                        },
                        [_vm._v("No")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "w-32",
                          staticStyle: { width: "200px" },
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.sendmailAndCancelBooking()
                            }
                          }
                        },
                        [_c("span", [_vm._v("Yes")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }